import { CheckPicker, SelectPicker } from "rsuite";

export type SinglePickerProps = {
    label: string;
    data: any[];
    value: string | number | null;
    width: number | string;
    labelKey: string;
    valueKey: string;
    onChange: (value: any) => void;
    className?: string;
    cleanable?: boolean;
    preventOverflow?: boolean;
    placeholder?: string;
    menuMaxHeight?: number;
    onClean?: () => void;
    onClose?: () => void;
};

export type MultiPickerProps = {
    label: string;
    data: any[];
    value: string[];
    width: number | string;
    labelKey: string;
    valueKey: string;
    onChange: (value: string[]) => void;
    className?: string;
    cleanable?: boolean;
    preventOverflow?: boolean;
    placeholder?: string;
    menuMaxHeight?: number;
    sticky?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    onClean?: () => void;
};

export const FilterSinglePicker = ({
    label,
    data,
    value,
    width,
    labelKey,
    valueKey,
    onChange,
    className = "flex flex-col justify-start items-start",
    cleanable = false,
    preventOverflow = false,
    placeholder,
    menuMaxHeight,
    onClean,
    onClose,
}: SinglePickerProps) => (
    <div className={className}>
        <label className="font-bold text-[0.8vw]">{label}</label>
        <SelectPicker
            data={data}
            value={value}
            style={{ width }}
            labelKey={labelKey}
            valueKey={valueKey}
            onChange={onChange}
            cleanable={cleanable}
            preventOverflow={preventOverflow}
            placeholder={placeholder}
            menuMaxHeight={menuMaxHeight}
            onClean={onClean}
            onClose={onClose}
        />
    </div>
);

export const FilterMultiPicker = ({
    label,
    data,
    value,
    width,
    labelKey,
    valueKey,
    onChange,
    className = "flex flex-col justify-start items-start max-w-[max(180px,10vw)]",
    cleanable = true,
    preventOverflow = false,
    placeholder = "All",
    menuMaxHeight,
    sticky = true,
    onOpen,
    onClose,
    onClean,
}: MultiPickerProps) => (
    <div className={className}>
        <label className="font-bold text-[0.8vw]">{label}</label>
        <CheckPicker
            sticky={sticky}
            data={data}
            value={value}
            style={{ width }}
            labelKey={labelKey}
            valueKey={valueKey}
            onChange={onChange}
            cleanable={cleanable}
            preventOverflow={preventOverflow}
            placeholder={placeholder}
            menuMaxHeight={menuMaxHeight}
            onOpen={onOpen}
            onClose={onClose}
            onClean={onClean}
        />
    </div>
);
